import {
  ApiService,
} from '@/internal';

export default class AdminService extends ApiService {

  index(payload = {}) {

    const {params} = payload;

    return this.request({
      method: 'get',
      url: '/admin',
      params: this.prepareParams(params),
    });
  }

  requestDebug(payload = {}) {

    const {params} = payload;

    return this.request({
      method: 'get',
      url: '/admin/debug/request',
      params: this.prepareParams(params),
    });
  }

  featureIdeas(payload = {}) {

    const {params} = payload;

    return this.request({
      method: 'get',
      url: '/admin/feature-ideas',
      params: this.prepareParams(params),
    });
  }

  feedback(payload = {}) {

    const {params} = payload;

    return this.request({
      method: 'get',
      url: '/admin/feedback',
      params: this.prepareParams(params),
    });
  }

  productFeedback(payload = {}) {

    const {params} = payload;

    return this.request({
      method: 'get',
      url: '/admin/product-feedback',
      params: this.prepareParams(params),
    });
  }

  surveyResponses(payload = {}) {

    const {params} = payload;

    return this.request({
      method: 'get',
      url: '/admin/survey-responses',
      params: this.prepareParams(params),
    });
  }

  updateFeatureIdea(id, payload = {}) {

    const { params, ...rest } = payload;

    return this.request({
      method: 'patch',
      url: `/admin/feature-ideas/${id}`,
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }

  updateProductFeedback(id, payload = {}) {

    const { params, ...rest } = payload;

    return this.request({
      method: 'patch',
      url: `/admin/product-feedback/${id}`,
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }

  deleteProductFeedback(id) {

    return this.request({
      method: 'delete',
      url: `/admin/product-feedback/${id}`,
    });
  }

  searchUsers(payload = {}) {

    const { params, ...rest } = payload;

    return this.request({
      method: 'post',
      url: '/admin/users/search',
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }

}
